import React from 'react';
import styled from 'styled-components';

import TextPrompt from '../text-prompt';

interface IRadio extends React.ComponentPropsWithoutRef<'input'> {
	error?: string | undefined;
}

// eslint-disable-next-line react/display-name
export const TypeRadio = React.forwardRef(({ error, ...props }: IRadio, ref) => (
	<RadioComponent className='form-control-container'>
		<input
			{...props}
			className={`text-radio ${props.className}`}
			ref={ref as React.LegacyRef<HTMLInputElement> | undefined}
			type='radio'
		/>
		{!!error && (
			<TextPrompt
				prompt={error}
				status={false}
			/>
		)}
	</RadioComponent>
));

const RadioComponent = styled.div`
	input {
		outline: none;
		border-radius: 3px;
		height: 14px;
		width: 14px;
		border: 1px solid #a1a1a1;
	}
`;
